export const CONTINENT_CODES = [
    'AF',
    'NA',
    'OC',
    'AN',
    'AS',
    'EU',
    'SA'
];
